import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export const facilities: racehorse360.IListFacilitiesRequest = {
  query: {
    isActive: { value: true }
  },
  pagingOptions: {
    maxResults: 20 // arbitrary.. should be enough for now
  },
  getOptions: {
    select: [
      "name",
      "backgroundColor",
      "foregroundColor",
      "strokeColor",
      "code",
      "type"
    ],
    orderBy: ["name"]
  }
};

export const roles: racehorse360.IListRolesRequest = {
  query: {
    isUserRequestable: { value: true }
  },
  pagingOptions: {
    maxResults: 20 // arbitrary.. should be enough for now
  },
  getOptions: {
    select: ["name", "roleType"],
    orderBy: ["name"]
  }
};

export const myRoles = (
  userId: string
): racehorse360.IListUserRoleRequestsRequest => ({
  query: {
    userIds: [userId],
    userRoleRequestStatuses: [
      racehorse360.UserRoleRequestStatus.USER_ROLE_REQUEST_STATUS_REQUESTED,
      racehorse360.UserRoleRequestStatus.USER_ROLE_REQUEST_STATUS_APPROVED
    ]
  },
  pagingOptions: {
    maxResults: 20 // arbitrary.. should be enough for now
  },
  getOptions: {
    select: [
      "facility.name",
      "role.name",
      "role.roleType",
      "trainerName",
      "userRoleRequestStatus"
    ],
    orderBy: ["role.name"]
  }
});

export const myProfile = (userId: string): racehorse360.IGetUserRequest => ({
  id: userId,
  getOptions: {
    select: ["firstName", "lastName", "phoneNumber", "licenseNumber", "email"]
  }
});
